import { FaRing } from 'react-icons/fa';
import images from './images';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaRing />,
    title: 'Basic Package',
    price: 1500,
    features: [
      'Initial consultation',
      'Budget planning',
      'Venue recommendations',
      'Vendor suggestions',
      'Basic day-of coordination',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaRing />,
    title: 'Standard Package',
    price: 3000,
    features: [
      'Full event planning',
      'Custom design consultation',
      'Venue booking assistance',
      'Vendor management',
      'Full day-of coordination',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaRing />,
    title: 'Premium Package',
    price: 5000,
    features: [
      'Complete planning and design',
      'Personalized event styling',
      'Full vendor coordination',
      'Comprehensive venue management',
      'Exclusive post-wedding support',
    ],
  },
];

export default pricing;